import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { TreoModule } from '@treo';
import { TreoConfigModule } from '@treo/services/config';
import { TreoMockApiModule } from '@treo/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockDataServices } from 'app/data/mock';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';

import { ToastrModule } from 'ngx-toastr';


import ptBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { CodigodeacessoComponent } from './modules/admin/dialogs/codigodeacesso/codigodeacesso.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DialogComponent } from './modules/admin/usuarios/apostador/dialog/dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TreoCardModule } from '@treo/components/card';
import { IMaskModule } from 'angular-imask';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';

registerLocaleData(ptBr)





const routerConfig: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: PreloadAllModules,
    relativeLinkResolution: 'legacy'
};

@NgModule({
    declarations: [
        AppComponent,
        CodigodeacessoComponent,
        DialogComponent
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),


        // Treo & Treo Mock API
        TreoModule,
        TreoConfigModule.forRoot(appConfig),
        TreoMockApiModule.forRoot(mockDataServices),

        // Core
        CoreModule,
        FormsModule,
        ReactiveFormsModule ,
        MatInputModule,
        // Layout
        LayoutModule,

        // 3rd party modules
        MarkdownModule.forRoot({}),
        HttpClientModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,

        ToastrModule.forRoot(),


        TreoCardModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatDividerModule,
        MatSliderModule,
        MatMenuModule,
        MatProgressBarModule,
        MatTooltipModule,
        IMaskModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        NgxShimmerLoadingModule
    ],
    entryComponents: [],
    providers: [HttpClient],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
